module.exports = __webpack_public_path__ + "img/pin_flat2.d8f1a777.svg";